import Loadable from "../../components/Loadable";
import { lazy } from "react";
import { REPORTS } from "../../utils/constant";

const CustomReport = Loadable(lazy(() => import("./CustomReport")));
const StatusReport = Loadable(lazy(() => import("./StatusReport")));
const StatusWiseReport = Loadable(lazy(() => import("./StatusWiseReport")));
const ExcecutiveWiseReport = Loadable(lazy(() => import("./ExcecutiveWiseReport")));
const ReportsDashboard = Loadable(lazy(() => import("./ReportsDashboard")));
const FollowUpReport = Loadable(lazy(() => import("./FollowUpReport")));
const EmployeePerformanceReport = Loadable(lazy(() => import("./EmployeePerformanceReport")));

const reportRoutes = [
  {
    path: "/report/dashboard",
    element: <ReportsDashboard />,
    permission: REPORTS,
  },
  {
    path: "/report/report",
    element: <CustomReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/statusReport",
    element: <StatusReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/statusWiseReport",
    element: <StatusWiseReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/ExecutiveWiseReport",
    element: <ExcecutiveWiseReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/followup-report",
    element: <FollowUpReport/>,
    permission: REPORTS,
  },
  {
    path: "/report/performanceReport",
    element: <EmployeePerformanceReport />,
    permission: REPORTS,
  },
];
export default reportRoutes;
